import { adminApi } from './api';

/* ==========================================
  매니저 관리 (ADMIN, FT, OPERATOR) Management)
========================================== */

/* 퍼실리테이터(FT) 또는 교육운영자(OP)를 여러 그룹에 매핑 */
export const mapUserToGroups = async (userId, groupIds) => {
    const response = await adminApi.put(`/api/admin/managers/${userId}/groups`, { groupIds });
    return response.data.data;
};

/* 매니저 롤 그룹 매핑 조회 */
export const getManagerGroups = async (userId) => {
    const response = await adminApi.get(`/api/admin/managers/${userId}/groups`);
    return response.data.data;
};